import { get, post } from "@/utils/http";
import "babel-polyfill";
// 会议室信息
export function allLists(params) {
  return post("/terminal/allList", params);
}

// 终端模板
export function models(params) {
  return post("/terminal/getBackground", params);
}

// 广告模板
export function releases(params) {
  return post("/terminal/release", params);
}

// ip和mac
export function getDatas(params) {
  return post("/ipMac/getData", params);
}

// 签到
export function personLists(params) {
  return post("/terminal/personList", params);
}
// 预约接口
// 查询会议室列表
export function meetingLists(params) {
  return post("/terminal/meetingInfoList", params);
}
// 预约状态
export function timeStatus(params) {
  return post("/terminal/timeStatus", params);
}

// 新增会议
export function addOrders(params) {
  return post("/terminal/addOrder", params);
}
// 修改会议
export function editOrders(params) {
  return post("/terminal/editOrders", params);
}
//预约成功后查看
export function atPresent(params) {
  return post("/terminal/atPresent", params);
}
//预约获取占用时间
export function findMeetingTime(params) {
  return post("/terminal/findMeetingTime", params);
}
//取消预约
export function cancelOrder(params) {
  return post("/terminal/cancelOrder", params);
}
//人脸识别签到
export function saveToImgByStr(params) {
  return post("/faceManage/saveToImgByStr", params);
}
//保洁人脸识别签到
export function cleanLogins(params) {
  return post("/terminal/cleanLogin", params);
}
//防疫人脸识别签到
export function antiepLogin(params) {
  return post("/terminal/antiepLogin", params);
}
//二维码签到接口
export function signOnByQRCode(params) {
  return post("/terminal/signOnByQRCode", params);
}
//会议模板获取接口
export function getMeetModel(params) {
  return post("/terminal/getMeetModel", params);
}
//广告模板获取接口
export function getAdModel(params) {
  return post("/terminal/getAdModel", params);
}

// 会议结束调后端接口保存历史数据
export function saveAttendeeHistorys(params) {
  return post("/terminal/saveAttendeeHistory", params);
}
// 会议结束调后端接口保存历史数据
export function saveOrderHistory(params) {
  return post("/terminal/saveOrderHistory", params);
}
//人脸识别接口
export function signOnByFace(params) {
  return post("/terminal/signOnByFace", params);
}
// 状态更新
export function statusUpdates(params) {
  return get("/terminal/termOnlineInfo",params);
}



// WEBPACK FOOTER //
// ./src/utils/request.js